import { Alert, List } from '@mantine/core'
import { useSelector } from 'react-redux'
import Message from '../../i18n/Message'

/** Lists what the owner still has to configure. Booleans only come from the server. */
export default function ConfigBanner({ blockingOnly = false }) {
  const config = useSelector((s) => s.auth.config) || {}
  const items = [
    { id: 'config_encryption', missing: !config.encryptionConfigured, blocking: true },
    { id: 'config_key_mismatch', missing: !!config.encryptionKeyMismatch, blocking: true },
    { id: 'config_storage', missing: config.storageConfigured === false, blocking: true },
    { id: 'config_paystack', missing: !config.paystackConfigured, blocking: false },
    { id: 'config_sms', missing: !config.smsConfigured, blocking: false },
  ].filter((i) => i.missing && (!blockingOnly || i.blocking))
  if (items.length === 0) return null
  return (
    <Alert color="orange" title={<Message id="config_title" />} mb="lg">
      <List size="sm" spacing={4}>
        {items.map((i) => (
          <List.Item key={i.id}>
            <Message id={i.id} />
          </List.Item>
        ))}
      </List>
    </Alert>
  )
}
